// test2745
(2745 && 0);
